module.exports = __webpack_public_path__ + "static/media/sculptureWrong.91bef5c6.png";